import React, { useEffect, useState } from 'react'
import Layout from '../components/Layout'
import { useDispatch, useSelector } from 'react-redux'
import { Link } from 'react-router-dom'
import '../stylings/galleryAll.css'
import { hideLoading, showLoading } from '../redux store/loader'
import moment from 'moment'

const GalleryAll = () => {
  const dispatch = useDispatch()
  const { photoGallery } = useSelector((state) => state.photoGallery)
  const [search, setSearch] = useState('')

  useEffect(() => {
    dispatch(showLoading())
    setTimeout(() => { dispatch(hideLoading()) }, 1700)
  }, [])

  const filtered = photoGallery
    ? photoGallery.filter((item) =>
        item.title.toLowerCase().includes(search.toLowerCase())
      )
    : []

  return (
    <Layout>
      <div className="ga-page">

        {/* ── Hero ── */}
        <div className="ga-hero">
          <div className="ga-hero-dots" />
          <div className="ga-hero-blob ga-hero-blob--1" />
          <div className="ga-hero-blob ga-hero-blob--2" />
          <div className="container ga-hero-inner">
            <div className="ga-hero-tag">
              <i className="fa-solid fa-images"></i> Photo Gallery
            </div>
            <h1 className="ga-hero-title">All Photo Albums</h1>
            <p className="ga-hero-sub">
              Relive our school's most memorable moments — events, celebrations, achievements and everyday life.
            </p>

            {/* Search */}
            <div className="ga-search-wrap">
              <i className="fa-solid fa-magnifying-glass ga-search-icon"></i>
              <input
                type="text"
                className="ga-search-input"
                placeholder="Search albums by title…"
                value={search}
                onChange={(e) => setSearch(e.target.value)}
              />
              {search && (
                <button className="ga-search-clear" onClick={() => setSearch('')}>
                  <i className="fa-solid fa-xmark"></i>
                </button>
              )}
            </div>
          </div>
        </div>

        {/* ── Content ── */}
        <div className="container ga-body">

          {/* Summary row */}
          {photoGallery && photoGallery.length > 0 && (
            <div className="ga-summary">
              <span className="ga-summary-count">
                <i className="fa-solid fa-layer-group"></i>
                {filtered.length} {filtered.length === 1 ? 'album' : 'albums'}
                {search && ` for "${search}"`}
              </span>
              <span className="ga-summary-label">Sorted by latest</span>
            </div>
          )}

          {/* Grid */}
          {!photoGallery || photoGallery.length === 0 ? (
            <div className="ga-empty">
              <div className="ga-empty-icon"><i className="fa-solid fa-images"></i></div>
              <h3>No Albums Yet</h3>
              <p>Photo albums will appear here once they are published.</p>
            </div>
          ) : filtered.length === 0 ? (
            <div className="ga-empty">
              <div className="ga-empty-icon"><i className="fa-solid fa-magnifying-glass"></i></div>
              <h3>No Results Found</h3>
              <p>No albums match "<strong>{search}</strong>". Try a different keyword.</p>
            </div>
          ) : (
            <div className="ga-grid">
              {filtered.map((item) =>
                item.attachments.map((att, ai) => ai < 1 && (
                  <Link
                    key={item.id}
                    to={`/gallery/${att.attachforid}`}
                    className="ga-card"
                  >
                    {/* Cover image */}
                    <div className="ga-card-img-wrap">
                      <img
                        src={att.path}
                        alt={item.title}
                        className="ga-card-img"
                        onError={(e) => { e.target.style.display = 'none' }}
                      />
                      <div className="ga-card-vignette" />

                      {/* Photo count badge */}
                      <div className="ga-card-count">
                        <i className="fa-solid fa-camera"></i>
                        {item.attachments.length} {item.attachments.length === 1 ? 'photo' : 'photos'}
                      </div>

                      {/* Hover overlay */}
                      <div className="ga-card-hover">
                        <div className="ga-card-view-btn">
                          <i className="fa-solid fa-eye"></i>
                          View Album
                        </div>
                      </div>
                    </div>

                    {/* Footer */}
                    <div className="ga-card-foot">
                      <h3 className="ga-card-title">{item.title}</h3>
                      <div className="ga-card-meta">
                        <span className="ga-card-date">
                          <i className="fa-solid fa-calendar-days"></i>
                          {moment(item.eventdate).format('DD MMM YYYY')}
                        </span>
                        <span className="ga-card-arrow">
                          <i className="fa-solid fa-arrow-right"></i>
                        </span>
                      </div>
                    </div>
                  </Link>
                ))
              )}
            </div>
          )}

        </div>
      </div>
    </Layout>
  )
}

export default GalleryAll
